import Vue from 'vue';
import Vuex from 'vuex';
// import i18n from "@/helpers/dataConverter/i18n";
import { store } from '@moeco-platform/moeco-components';
const { errors } = store;
import shipments from './modules/shipments';
import packageDetails from './modules/packageDetails';
import sensorTypes from './modules/sensorTypes';
import layout from './modules/layout';
import location from './modules/location';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  namespaced: true,
  modules: {
    packageDetails,
    shipments,
    errors,
    sensorTypes,
    layout,
    location
  }
});
